import browser from 'browser-detect'

export const waitFor = (amount: number): Promise<void> =>
  new Promise<void>(res => setTimeout(res, amount))

export const timeoutAfter =
  (ms: number) =>
  <T>(p: () => void | Promise<T>) =>
    Promise.race([p(), waitFor(ms)])

/**
 * YAWEB-667
 * Safari 브라우저 > 통합주문 (platform-site.yanolja.com) > platform-site 도메인 외부로 navigate 하는 버튼 클릭
 *
 * 위 버튼에 할당된 kinesis log 호출이 있다면, 해당 kinesis log는 aborted 됨.
 *
 * 이는 safari 브라우저 내부 동작으로 보이며 외부 도메인으로 navigation 발생시 백그라운드에서 실행되는 함수 abort.
 * platform-site 간 이동은 CSR 으로 이루어지고 있기에 문제가 없는듯
 *
 * safari 에서 외부 도메인으로 이동되는 click 로그인 경우 timeout 을 주어 kinesis log 가 aborted 되는 것을 방지
 */
export const sendKinesisClickLogTimeoutAfter = async <T>(p: () => void | Promise<T>) => {
  if (browser(window.navigator.userAgent).name === 'safari') {
    return timeoutAfter(500)<T>(p)
  } else {
    return p()
  }
}
